module.exports = __webpack_public_path__ + "img/alert.f20218d5.jpg";